<template>
    <v-card class="eventday">
        <v-card-text>
            <h3 class="eventdaytitle">{{ day | filterDate }}</h3>
            <v-col v-if="!record || !record.length">
                <v-card
                    class="pa-2"
                    flat
                >{{  mergedConfig.noeventstext || "No Events Reported" }}</v-card>
            </v-col>
            <template v-else>
                <v-col v-for="(item) in record" :key="item.key" class="event">
                    <div v-if="item.type !== 'start'">
                        <div v-if="mergedConfig.showConfig && !hasNote(item) && (addingNote !== item.key)" class="createnote float-right">
                            <v-btn outlined small @click="toggleEdit({key: item.key, start: item.start}, 'new')">Add Note</v-btn>
                        </div>
                        <v-row class="eventdetailrow">
                            <v-card class="eventdesc" flat>
                                {{item.type | filterFirstLetter }} {{item | filterDistance}}
                                <span v-if="item.message">:</span>
                                {{item.message}}
                            </v-card>
                        </v-row>
                        <v-row class="eventdetailrow">
                            <v-card class="eventtimes" flat>
                                {{item.start | filterTime}}
                                <span v-if="item.end">to {{item.end | filterTime}}</span>
                            </v-card>
                        </v-row>

                        <v-row v-if="mergedConfig.showConfig && (addingNote === item.key)" class="eventnote">
                            <v-col>
                                <v-textarea name="noteMessage" v-model="editMessage" label="Add Note" rows="5" auto-grow>
                                </v-textarea>
                            </v-col>
                            <v-col class="noteactions">
                                <v-row>
                                    <v-checkbox v-model="isPublic" label="Post is Public" ></v-checkbox>
                                </v-row>
                                <v-row>
                                    <v-btn @click="toggleEdit({key: item.key})" outlined small>Cancel</v-btn>  <v-btn @click="saveMessage({key: item.key})" outlined small>Save</v-btn>
                                </v-row>
                             </v-col>
                        </v-row>

                        <div v-for="entry in item.data"  :key="entry.key">
                            <template v-if="entry.type==='note'">
                                <v-row v-if="mergedConfig.showConfig && showNoteEdit === entry.key" class="eventnote eventnoteform">
                                    <v-col>
                                        <v-textarea name="noteMessage" v-model="editMessage" label="Edit Note" rows="5" auto-grow>
                                        </v-textarea>
                                    </v-col>
                                    <v-col class="noteactions">
                                        <v-row>
                                            <v-checkbox v-model="isPublic" label="Post is Public" ></v-checkbox>
                                        </v-row>
                                        <v-row>
                                            <v-btn @click="toggleEdit(entry)" outlined small>Cancel</v-btn>  <v-btn @click="saveMessage(entry)" outlined small>Save</v-btn>
                                        </v-row>
                                        <v-spacer></v-spacer>
                                        <v-row class="deleterow" >
                                            <v-btn @click="removeNote(entry)" outlined small>Delete Note</v-btn>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                 <v-row v-else class='eventnote'>
                                    <v-col class='notetext' v-if="entry.data && entry.data.message" v-html="entry.data.message">
                                    </v-col>
                                    <v-col class='nottext' v-else-if="entry.data">
                                        <code>{{entry.data}}</code>
                                    </v-col>
                                     <v-col class="noteactions">
                                        <div v-if="mergedConfig.showConfig" >{{entry.visibility | filterFirstLetter}}</div>
                                        <v-btn v-if="mergedConfig.showConfig" outlined small @click="toggleEdit(entry)">Edit Note</v-btn>
                                     </v-col>
                                </v-row>
                            </template>

                            <div v-else-if="showdiag === entry.key && entry.data" class="diagnosticscontainer">
                                <v-btn @click="showdiag=false" outlined small class="showdiagbuttontop">{{ sizing.closediag }}</v-btn>
                                <EventsDiagnosticsView :entry="entry" />
                                <v-btn @click="showdiag=false" outlined small class="showdiagbuttonbottom">{{ sizing.closediag }}</v-btn>
                            </div>

                            <template v-else>
                                <v-row>
                                    <v-btn @click="showdiag=entry.key" outlined small class="showdiagbuttonbottom hidden-md-and-up">Open</v-btn>
                                    <v-btn @click="showdiag=entry.key" outlined small class="showdiagbuttonbottom hidden-sm-and-down">Diagnostic: {{ entry.data.tool }} from {{ (entry.data.location || "unknown") }} - {{ (entry.data.results && entry.data.results.start) | filterTimeFrom }}</v-btn>
                                </v-row>
                            </template>
                        </div>
                    </div>
                    <div v-else>
                        <v-row>
                            <v-card class="eventdesc" flat >
                                Monitoring started at {{ item.startlocal | filterTime}}
                            </v-card>
                        </v-row>
                    </div>
                </v-col>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    format as date_format,
    parse as date_parse,
    distanceInWordsStrict as date_distance
} from "date-fns";
import { formatCapitalizeFirst } from "../lib/filter";

import EventsDiagnosticsView from "./Events_Diagnostics_View";

// import _find from "lodash/find";

export default {
    name: "ReportEventsDay",
    data() {
        return {
            showdiag: false,
            showscreenshot: false,
            showNoteEdit: false,
            addingNote: false,
            editMessage: false,
            isPublic: false,
            created: false
        };
    },
    props: {
        record: { type: Array },
        day: { type: String }
    },
    // components: { GChart },
    components: { EventsDiagnosticsView },
    computed: {
        ...mapState(["now", "reports_checkstatus"]),
        ...mapGetters("reports_checkstatus", ["mergedConfig"]),
        sizing: function () {
            let breakpoint = this.$vuetify.breakpoint;
            let screenshotsize = breakpoint.width * 0.64;
            return {
                breakpoint: breakpoint,
                screenshotsize: screenshotsize,
                opendiag: (breakpoint.name === "sm" || breakpoint.name === "xs") ? "Open" : "Show diagnostic info",
                closediag: (breakpoint.name === "sm" || breakpoint.name === "xs") ? "Close" : "Close"
            }
        }
    },
    methods: {
        hasNote: function( item ){
            if(!item || !item.data) return;
            let idlength = item.data.length;
            for(let i=0;i<idlength;i++){
                if(item.data[i].type === "note") return true;
            }
            return false;
        },
        toggleEdit: function( entry, options ) {
            // console.log('toggleEdit', entry, options);
            if(options === "new"){
                this.addingNote = entry.key;
                this.showNoteEdit = entry.key + "-" + Date.now();
                this.editMessage = "";
                this.eventstart = entry.start;
                this.isPublic = false;
                this.created = false;
            } else if(this.showNoteEdit === entry.key){
                this.addingNote = false;
                this.showNoteEdit = false;
                this.editMessage = false;
                this.eventstart = false;
                this.isPublic = false;
                this.created = false;
            } else {
                this.addingNote = false;
                this.showNoteEdit = entry.key;
                this.editMessage = entry.data && (entry.data.message || entry.data);
                this.eventstart = entry.start;
                this.isPublic = (entry.visibility === "public");
                this.created = entry.created;
            }
        },
        // setMessage: function(a) {
        //     this.editMessage = a;
        //     console.log('setMessage', a, b);
        // },
        saveMessage: function(entry) {
            // console.log('saveMessage',entry, this.editMessage);

            let record = {
                start: this.eventstart,
                visibility: this.isPublic ? "public" : "private",
                data: {
                    message: this.editMessage
                }
            };
            if(this.created) record.created = this.created;

            this.$store.dispatch('reports_checkstatus/setEventDataNote', record)
                .then( ( result ) => {
                    // console.log('saved message', result);
                    this.toggleEdit(entry);
                })
                .catch( (e) => {
                    console.log("ERROR", e)
                });
        },
        removeNote: function(entry) {
            console.log('removeNote', entry);

            this.$store.dispatch('reports_checkstatus/removeEventDataNote', entry)
                .then( ( result ) => {
                    console.log('removed the note', result)
                    this.toggleEdit(entry)
                })
                .catch( (error) => {
                    console.log("ERROR", error.response || error);
                    error = (error && error.response && error) || {
                        response: 500,
                        data: {}
                    }
                    return error;
                });

        },
        screenshotSrc: function(val) {
            return 'data:image/png;base64,' + val;
        }
    },
    filters: {
        filterTimeFrom: function(val) {
            if(val){
                let d =  date_format(date_parse(val - 0), "MMM D HH:mm:ss");
                return (d && d !== "NaN" && d !== "Invalid Date") ? d : "";
            } else {
                return "";
            }
            // return date_format(date_parse(val - 0), "MMM D HH:mm:ss");
        },
        filterTimeTo: function(val) {
            if(val){
                let d =  date_format(date_parse(val - 0), "HH:mm:ss");
                return (d && d !== "NaN" && d !== "Invalid Date") ? d : "";
            } else {
                return "";
            }
            // if(val) return date_format(date_parse(val - 0), "HH:mm:ss");
        },
        filterDate: function(val) {
            if(val){
                let d =  date_format(date_parse(val), "MMM D, YYYY");
                return (d && d !== "NaN" && d !== "Invalid Date") ? d : "";
            } else {
                return "";
            }
            // if(val) return date_format(date_parse(val), "MMM D, YYYY");
        },
        filterTime: function(val) {
            if(val){
                let d =  date_format(date_parse(val), "YYYY-MM-DD HH:mm:ss");
                return (d && d !== "NaN" && d !== "Invalid Date") ? d : "";
            } else {
                return "";
            }
            // if(val) return date_format(date_parse(val), "YYYY-MM-DD HH:mm:ss");
        },
        filterDistance: function(val) {
            if(val && val.start && val.end){
                let d =  date_distance(val.start, val.end);
                if(d && d !== "almost NaN years" && d !== "Invalid Date" && d.indexOf('NaN') < 0){
                    return "for " + d;
                }
            }
            return "";

            // if (val.start && val.end) return "for " + date_distance(val.start, val.end);
        },
        filterFirstLetter: function(val) {
            if(val) return formatCapitalizeFirst(val);
        }
    }
};
</script>

<style scoped>
.eventday {
    margin-bottom: 1rem;
}
.eventdaytitle {
    margin-bottom: 1rem;
}
.event {
    margin-bottom: 1rem;
    margin-left: 1rem;
    padding-left: 2rem;
    padding-right: 2rem;
    border-left: 2px solid #ddd;
}
.eventdesc {
    font-weight: bold;
}
.eventdetailrow {
    margin: 0 !important;
}
.eventnote {
    padding: 0 0 1em 1em;
    background: white;
    border-top: 1px solid #DDD;
    border-bottom: 1px solid #DDD;
}
.eventnote button {
    margin-right: 1em;
    height: 18px !important;
}
.notetext {
    color: #222;
    font-size: 1.1em;
}
.createnote button {
    height: 18px !important;
}
.deleterow {
    margin-top: 36px;
}
.noteactions {
    max-width: 228px;
    color: #333;
}
.createnote {
    max-width: 228px;
    padding-right: 100px;
}

.diagnosticscontainer {
    padding: 1rem;
    margin-top: 0.8rem;
    border-top: 1px solid #AAA;
    border-bottom: 1px solid #AAA;
}
.showdiagbuttonbottom {
    margin-top: 1.2rem;
    margin-right: 1rem;
}
.showdiagbuttontop {
    margin-right: 1rem;
    margin-bottom: 1.2rem;
}
@media screen and (max-width: 500px){
    .v-application .float-right {
        float: none !important;
        display: block;
        clear: both;
    }
}
</style>